{
  "helpMessage": "<h3>O iai ni au fesili?</h3>\n<p>Matou te sauni e fesoasoani – vili mai le matou 'au:<br/>\n<a><strong>☎️ {{phone}}</strong></a> (ona fetaomi lea o le <strong>Filifiliga 2</strong>)<br/>\nAso Gafua i le Aso Faraile, 8am–5pm.</p>",
  "text": "<p>O le a matou logoina lau foma‘i na toe fa‘asino mai, ma atonu o le a ia fa‘afeso‘ota‘i atu e talanoaina la‘asaga o lo‘o lumana‘i.</p>\n<p>Leai se isi mea e tatau ona e faia i le taimi nei.</p>",
  "title": "Ua e filifili e lē tusi se taimi i le taimi nei."
}
